<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">学习记录</span>
            </template>
            <template #left>
                <router-link to="/">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-tabs v-model="tabActive" @click="onLoad(true)">
            <van-tab title="考试记录" name="ks"></van-tab>
            <van-tab title="学习记录" name="xx"></van-tab>
        </van-tabs>

        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text="没有更多了"
                @load="onLoad(false)"
        >
            <van-collapse v-model="listActive">
                <van-panel v-for="item in topics"
                           :key="item.id"
                           :title="undefined === item.subject?'':item.subject.name"
                           :status="getPatternName(item.pattern)">
                    <div style="margin: 0 20px">
                        开始时间:{{ item.start_time }} <br>
                        结束时间:{{ item.end_time }}<br>
                        <div v-if="5 === item.pattern">
                            得分:{{ item.score }}
                        </div>
                    </div>

                    <template v-if="5 === item.pattern" #footer>
                        <div style="text-align: right">
                            <van-button size="small" @click="toFuJuan(item.id)">复卷</van-button>
                        </div>
                    </template>
                </van-panel>


            </van-collapse>
        </van-list>


    </div>
</template>

<script>
export default {
    data() {
        return {
            tabActive: 0,
            page: 1,
            listActive: [],

            loading: false,
            finished: false,
            error: false,
            error_text: "",
            searchValue: "",

            topics: []
        };
    },
    created() {

    },
    methods: {
        onLoad(isNew) {
            if (isNew) {
                this.topics = [];
                this.page = 1;
                this.finished = false;
            }
            this.loading = true;
            this.$http.get("/wechat/learns", {
                params: {
                    pre_page: 15,
                    page: this.page,
                    type: this.tabActive,
                    word: this.searchValue
                }
            }).then(res => {
                this.loading = false;
                console.log(res.data);
                if (200 !== res.data.code) {
                    this.error = true
                    this.error_text = res.data.msg
                    return
                }
                if (!res.data.data || res.data.data.length <= 0) {
                    this.finished = true
                    return;
                }
                this.page++

                this.topics = this.topics.concat(res.data.data);
            });
        },
        //复卷
        toFuJuan(id) {
            window.location.href = '/exercise?pattern=6&learn_id=' + id;
            // this.$router.push('/exercise?pattern=6&learn_id='+id);
        },

        getPatternName(pattern) {
            //模式:1顺序练习;2专项练习;3错题练习;5模拟考试;6复卷
            switch (pattern) {
                case 1:
                    return '顺序练习';
                case 2:
                    return '专项练习';
                case 3:
                    return '错题练习';
                case 5:
                    return '模拟考试';
                case 6:
                    return '复卷';
                default:
                    return '学易通';
            }
        },
    }
}
</script>
